// src/pages/admin/Bookings/components/DeleteConfirmDialog.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const DeleteConfirmDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Delete Order?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        This action cannot be undone. Are you sure you want to delete this
        order?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Yes, I’m sure
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirmDialog;
